import * as React from "react";
import type { CloseDialog, OpenDialog } from "./useDialogs";

export const DialogsContext = React.createContext<{
  open: OpenDialog;
  close: CloseDialog;
} | null>(null);
